module.exports = __webpack_public_path__ + "images/mercator-a52764d2742731d8a9cd1c210ffb3874.jpg";